module.exports = __webpack_public_path__ + "static/shop-123e043eed2cd44c94630c99e75819fd.png";